export default __webpack_public_path__ + "static/media/Emergencia-orange.16a2ca4d.svg";